// Helpers for rendering user-controlled content safely. Trail managers'
// text (names, notices, menus, links) is shown to the public and inside
// third-party embeds, so treat all of it as untrusted.
import DOMPurify from 'dompurify'

// Allow only web, mail and phone links; anything else becomes '#'.
export function safeUrl (url) {
  if (!url) return '#'
  try {
    const parsed = new URL(String(url).trim(), window.location.origin)
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol) ? parsed.href : '#'
  } catch (err) {
    return '#'
  }
}

// Clean rich text (Quill menus, calendar descriptions) before v-html.
export function sanitizeHtml (html) {
  return DOMPurify.sanitize(String(html || ''), { USE_PROFILES: { html: true }, ADD_ATTR: ['target'] })
}

export function escapeHtml (s) {
  return String(s === undefined || s === null ? '' : s)
    .replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}

// YouTube video id from a watch/share/embed URL, or null.
export function youTubeId (url) {
  const match = String(url || '').match(/(?:youtu\.be\/|v\/|u\/\w\/|embed\/|live\/|watch\?v=|&v=)([A-Za-z0-9_-]{11})(?![A-Za-z0-9_-])/)
  return match ? match[1] : null
}

// Links in sanitized HTML open safely in a new tab.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') node.setAttribute('rel', 'noopener noreferrer')
})
